// extracted by mini-css-extract-plugin
module.exports = {"root":"_a19dcd","avatar":"_c9c8a5"};